export default __webpack_public_path__ + "0048748e11491de91955751adf63d16f.png";